module.exports = __webpack_public_path__ + "static/media/3.51f7d912.jpg";